import { AfterViewInit, Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthStoreAction, RootStoreState } from 'src/app/root-store';
import { PreferencesAction } from 'src/app/root-store/preferences-store';
import { AuthService } from 'src/app/services/auth/auth.service';
import { BaseComponent } from 'src/app/shared/base-components/base-component';

@Component({
  selector: 'app-viewasuser-auth',
  templateUrl: './viewasuser-auth.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class ViewAsUserAuthComponent extends BaseComponent implements AfterViewInit {
  token: string;
  adminToken: string;
  isAuthenticated: any;

  constructor(
    private store: Store<RootStoreState.State>,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
  ) {
    super();
    // subscribe to router event

    this.token = sessionStorage.getItem('view-as-user-token');
    this.adminToken = sessionStorage.getItem('adminToken');
    sessionStorage.removeItem('view-as-user-token');
    sessionStorage.removeItem('adminToken');
  }
  ngAfterViewInit(): void {
    if (this.adminToken && this.authService.testToken(this.adminToken)) {
      if (this.token) {
        this.store.dispatch(AuthStoreAction.authAsUser({ token: this.token }));
      } else {
        this.router.navigate(['']);
      }
    } else {
      // this.router.navigate(['/auth/login']);
      this.router.navigate(['/auth/login']).then(() => {
        this.store.dispatch(PreferencesAction.loadPreferenceSettings({ isAuth: false, isTenantAdmin: false }));
      });
    }
  }
}
